var _style, _g, _path, _g2, _g3, _path2, _path3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g5, _path13, _path14, _g6, _path15, _path16, _g7, _path17, _path18, _g8, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g9, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAnimatedLogoFaceWhite = function SvgAnimatedLogoFaceWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "animated_logo_face_white_svg__face_main",
    viewBox: "0 0 490.22 483.22",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes face_main-g2_to__to{0%,to{transform:translate(194.464829px,211.598594px)}45%{transform:translate(190.464829px,207.598594px)}}@keyframes face_main-g2_tr__tr{0%,to{transform:rotate(0deg)}45%{transform:rotate(-2.741858deg)}}@keyframes face_main-g4_to__to{0%,to{transform:translate(377.740006px,192.252297px)}51%{transform:translate(365.740006px,195.252297px)}}@keyframes face_main-g4_tr__tr{0%,to{transform:rotate(0deg)}51%{transform:rotate(10.107797deg)}}@keyframes face_main-g5_to__to{0%,to{transform:translate(388.459992px,406.059998px)}40%{transform:translate(384.459992px,400.059998px)}71%{transform:translate(382.526659px,408.159998px)}}@keyframes face_main-g5_tr__tr{0%,to{transform:rotate(0deg)}40%{transform:rotate(6.308945deg)}71%{transform:rotate(-2.572392deg)}}@keyframes face_main-path272_to__to{0%{transform:translate(382.429832px,302.596443px)}44%{transform:translate(364.742524px,297.376443px)}to{transform:translate(382.429831px,302.596443px)}}@keyframes face_main-path272_tr__tr{0%,to{transform:rotate(0deg)}36%{transform:rotate(9.692386deg)}}@keyframes face_main-g6_to__to{0%,to{transform:translate(358.889999px,89.447079px)}48%{transform:translate(345.889999px,80.447079px)}}@keyframes face_main-g7_to__to{0%,to{transform:translate(379.225007px,18.705px)}35%{transform:translate(370.225007px,21.705px)}73%{transform:translate(372.486545px,16.951154px)}}@keyframes face_main-g8_to__to{0%,to{transform:translate(284.125px,442.844986px)}32%{transform:translate(279.125px,442.844986px)}55%{transform:translate(273.816176px,438.844986px)}}@keyframes face_main-g8_tr__tr{0%,to{transform:rotate(0deg)}32%{transform:rotate(-3.554098deg)}55%{transform:rotate(-6.481786deg)}}@keyframes face_main-g9_to__to{0%,to{transform:translate(294.429993px,382.004989px)}46%{transform:translate(286.429993px,374.004989px)}}@keyframes face_main-g9_tr__tr{0%,to{transform:rotate(0deg)}40%{transform:rotate(13.589928deg)}}@keyframes face_main-g10_to__to{0%,to{transform:translate(458.480011px,157.939445px)}50%{transform:translate(432.480011px,148.939445px)}}@keyframes face_main-g10_tr__tr{0%,to{transform:rotate(0deg)}50%{transform:rotate(-27.997147deg)}}@keyframes face_main-path301_to__to{0%,to{transform:translate(150.93px,413.42px)}49%{transform:translate(150.93px,411.42px)}}@keyframes face_main-path301_tr__tr{0%,to{transform:rotate(0deg)}49%{transform:rotate(19.550445deg)}}@keyframes face_main-g11_to__to{0%,to{transform:translate(477.165009px,385.179993px)}38%{transform:translate(462.572416px,383.352833px)}69%{transform:translate(467.868713px,375.266413px)}}@keyframes face_main-g11_tr__tr{0%,to{transform:rotate(0deg)}21%{transform:rotate(-6.733789deg)}46%{transform:rotate(1.81018deg)}69%{transform:rotate(-7.784857deg)}}")), /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g1",
    transform: "matrix(.95393 0 0 .95393 11.22 11.098)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-g2_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.465 211.599)",
    style: {
      animation: "face_main-g2_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g2",
    transform: "translate(-194.465 -211.599)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path1",
    d: "M332.84 179.39c1.59 2.15 3.21 4.28 4.76 6.45 2 2.78 3.94 5.59 5.89 8.41 3.09 4.47 6.19 8.95 9.24 13.45 2.14 3.15 4.16 6.38 6.33 9.52 2.32 3.36 4.79 6.61 7.12 10 1.52 2.19 2.85 4.51 4.37 6.7 2.09 3 4.32 5.87 6.42 8.85 2.38 3.38 4.67 6.82 7 10.22 2.47 3.56 5 7.1 7.43 10.65.34.5.66 1 1 1.54.56.92.38 1.63-.7 2.66l-8.7 8.24c-4.48 4.25-8.94 8.53-13.46 12.75-5.95 5.54-12 11-17.92 16.55-3.32 3.08-6.53 6.27-9.83 9.37s-6.36 5.88-9.51 8.84c-2.51 2.36-4.94 4.78-7.44 7.14-2.74 2.59-5.51 5.14-8.26 7.71a.92.92 0 00-.14.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path2",
    d: "M331 179.81c-.19 1-.37 2.06-.56 3.08-.08.43-.22.84-.28 1.27-.43 3.31-.84 6.63-1.26 9.94",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path3",
    d: "M328.64 195.65c-.19 1.12-.38 2.24-.56 3.36-.11.65-.2 1.31-.28 2-.19 1.54-.32 3.09-.58 4.62-.31 1.88-.81 3.73-1.09 5.61-.39 2.66-.6 5.34-1 8s-1 5.51-1.51 8.27c-.18 1.06-.16 2.15-.31 3.22-.18 1.27-.5 2.52-.68 3.78-.54 3.69-1 7.38-1.55 11.07-.28 2-.52 3.93-.85 5.89-.43 2.57-.93 5.14-1.39 7.71-.12.69-.2 1.4-.28 2.1-.11 1-.15 2-.29 2.94-.3 2.15-.59 4.31-1 6.44-.71 3.91-1 7.88-1.79 11.75-.55 2.86-.55 5.78-1.39 8.59a26.63 26.63 0 00-.45 3.49c-.55 3.41-1.12 6.82-1.68 10.23-.07.46-.07.94-.14 1.4-.18 1.12-.37 2.24-.56 3.36-.08.47-.22.93-.28 1.41-.38 3.08-.72 6.17-1.13 9.24-.27 2-.64 3.93-1 5.89-.56 3.32-1.16 6.63-1.67 9.95-.48 3.12-.85 6.26-1.28 9.39a7.21 7.21 0 01-.28 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g3",
    transform: "matrix(1.02831 0 0 .74852 -6.234 20.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path4",
    d: "M254.37 47.67c3.06 1.47 5.46 3.87 8.11 5.9 4.76 3.63 9.45 7.35 14.16 11.05 1.7 1.34 3.36 2.73 5.06 4.06 2 1.56 4 3.07 6 4.63 2.36 1.85 4.66 3.76 7 5.6 5 3.94 10.1 7.83 15.12 11.78 3.53 2.77 7 5.62 10.52 8.4 3 2.37 6.08 4.66 9.11 7 3.51 2.74 7 5.53 10.51 8.26s6.94 5.3 10.36 8c2.29 1.81 4.35 3.93 6.78 5.53 2.11 1.39 4 3 6 4.56 1.84 1.41 1.85 1.52.56 3.2-1.81 2.33-3.77 4.55-5.58 6.89s-3.34 4.59-5.07 6.84-3.46 4.3-5.17 6.46q-5.34 6.78-10.65 13.59c-1.37 1.76-2.71 3.55-4.07 5.33",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path5",
    d: "M164 24.54c2.31 3.05 3.69 6.61 5.46 10 1.41 2.66 2.82 5.32 4.2 8 .87 1.67 1.67 3.37 2.53 5 1.06 2 2.16 4 3.22 6 .86 1.63 1.67 3.28 2.53 4.9s1.69 3.08 2.51 4.63 1.5 2.9 2.25 4.34c.93 1.83 1.87 3.65 2.8 5.47 1.41 2.75 2.79 5.52 4.21 8.27q2.56 5 5.18 9.94c1.34 2.54 2.75 5 4 7.58 1.41 2.73 2.7 5.52 4.09 8.26.78 1.52 1.71 3 2.5 4.49s1.48 3.09 2.26 4.62c1.14 2.21 2.34 4.38 3.49 6.59s2.27 4.38 3.36 6.59c1 2 1.93 4.13 3 6.14.2.37.9.49 1.36.72",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path6",
    d: "M251.28 47.67c-.93 3.27-1.89 6.53-2.79 9.81-.79 2.84-1.33 5.76-2.32 8.52-.61 1.72-.7 3.55-1.5 5.26a35.6 35.6 0 00-1 3.75c-.83 2.51-1.36 5.12-2 7.69-.6 2.35-1.1 4.72-1.92 7-.56 1.57-.74 3.27-1.17 4.89s-1 3.45-1.53 5.19c-.34 1.16-.69 2.32-1 3.5-.44 1.82-.83 3.64-1.27 5.46-.36 1.5-.69 3-1.13 4.48s-1.05 3.08-1.52 4.63c-.69 2.28-1.37 4.57-2 6.87-.46 1.8-.73 3.65-1.16 5.46-.16.68-.63 1.29-.8 2-.39 1.57-.57 3.2-1 4.75a20.94 20.94 0 01-1.5 3.09",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path7",
    d: "M254.08 48.79c1 1.77 2 3.57 3.1 5.32 2.4 3.89 5 7.66 7.22 11.66 1.86 3.35 4 6.52 5.89 9.81s3.7 6.28 5.64 9.37c1.38 2.2 2.62 4.48 3.94 6.71 1.76 3 3.56 5.89 5.32 8.84 2.16 3.59 4.28 7.2 6.46 10.78 1.78 2.92 3.65 5.79 5.45 8.7 1.34 2.17 2.62 4.38 3.93 6.58",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path8",
    d: "M334.66 66.3a2.37 2.37 0 01-2-.08c-2-.68-4.09-1.07-6.14-1.6-1.69-.45-3.36-1-5.05-1.4-2-.53-4.05-.93-6-1.57S311.6 61 309.84 60c-.52-.29-1.32 0-1.94-.19-2.74-.77-5.47-1.54-8.26-2.14-2.35-.5-4.61-1.39-7-1.81-1.72-.3-3.36-1-5.06-1.48s-3.73-.86-5.6-1.28a8.77 8.77 0 01-1.12-.29 35.7 35.7 0 00-6.44-1.69c-.86-.16-1.67-.59-2.53-.81-2.42-.64-4.85-1.24-7.29-1.83-1.81-.44-3.68-.73-5.45-1.3-1.3-.42-2.5-1.1-3.93-.81",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path9",
    d: "M141 34.07c.176.41.313.835.41 1.27.22 1.39.38 2.8.58 4.2.11.75.29 1.49.41 2.24.39 2.43.72 4.86 1.13 7.29.58 3.41 1.21 6.82 1.83 10.23.065.198.156.386.27.56",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path10",
    d: "M145.9 61.68c.19 1.21.35 2.43.57 3.64.45 2.53.94 5 1.38 7.57.19 1.07.24 2.16.44 3.22.53 2.72 1.18 5.41 1.65 8.13s.76 5.42 1.15 8.13c.13.89.36 1.77.56 2.66.08.38.21.74.27 1.12.48 3.08.9 6.17 1.43 9.25.266 1.093 1.98 5.766 2.38 6.817",
    transform: "translate(-4.782 -13.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path11",
    d: "M162.3 37.16c-.19.51 1.176-14.49 1.036-13.95-.18.69-1.886 16.89-2.026 17.59",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path12",
    d: "M161 42.34c-.18 2.71-.34 5.42-.56 8.13-.35 4.25-1.064 30.213-1.444 34.463",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path14",
    d: "M335.5 66a15.72 15.72 0 00-2.26-2.21c-3.36-2.22-6.8-4.33-10.21-6.47S316.29 53.16 313 51c-2.18-1.4-4.28-2.93-6.46-4.32s-4.58-2.8-6.86-4.23c-2.12-1.32-4.21-2.69-6.31-4-3.22-2.1-6.43-4.22-9.67-6.3-2.37-1.53-4.76-3-7.14-4.49",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path15",
    d: "M274.82 28.05c-1.12.93-2.21 1.91-3.37 2.79-1.65 1.25-3.36 2.43-5 3.65l-9.53 7c-1.13.83-2.24 1.68-3.37 2.52",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path16",
    d: "M271.674 25.439c-1.322.377-24.51-7.757-25.854-8.049q-5.69-.54-11.35-1.12a5.07 5.07 0 01-.56-.13",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path17",
    d: "M232.08 15.86a40.37 40.37 0 01-5.17-.46 49.54 49.54 0 00-10.66-.66l-23.205.17",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path18",
    d: "M190 15.29a60.48 60.48 0 00-6.43 1.46c-2.08.69-4.23 1-6.32 1.62s-4.48 1.23-6.73 1.83c-1.67.44-3.36.84-5 1.26",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path19",
    d: "M160.33 23.14c-1.77.89-3.54 1.8-5.32 2.66s-3.47 1.57-5.18 2.39c-1.42.68-2.81 1.4-4.21 2.1-1.22.61-2.44 1.19-3.64 1.84a4.68 4.68 0 00-.85.82",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path20",
    d: "M139.59 33.86l-6 5.12q-5.4 4.62-10.79 9.25l-9 7.7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path21",
    d: "M163.28 38.14c.09 1.4.26 2.8.26 4.2v17.52c0 4.57.08 9.15.14 13.73q.12 8.2.28 16.4c.13 7.52.28 15 .41 22.56 0 .51 1.792 8.665 1.752 9.205",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path22",
    d: "M193 18c.79 3.36 1.53 6.74 2.4 10.08.44 1.71 1.15 3.36 1.64 5.06.45 1.52.73 3.08 1.15 4.61.59 2.16.77 4.42 1.8 6.46a5.3 5.3 0 01.16.83c.27 1 .58 2 .82 3 .09.509 23.768 86.866 23.777 87.383",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path23",
    d: "M110 59.44c-1.72 1.72-3.44 3.47-5.18 5.18-3.68 3.61-7.41 7.17-11.06 10.8-2.44 2.42-4.77 5-7.17 7.41a11.1 11.1 0 01-1.25 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path24",
    d: "M112.119 57.615l17.612 15.134",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path25",
    d: "M248.974 19.297c-.23 1.59 3.386 20.193 3.146 21.783-.07.47-.18.93-.28 1.4",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path26",
    d: "M268.38 24.12l6.3 2.67",
    transform: "translate(-4.78 -13.73)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path27",
    d: "M235.17 329.19c1.16.28 2.34.55 3.5.85 1.4.36 2.81.72 4.2 1.12 1.88.54 3.74 1.13 5.61 1.67s3.46.92 5.18 1.41 3.37 1 5 1.54c.28.09.56.2.84.28l6.17 1.68c1.45.41 2.89.84 4.34 1.26l5.61 1.68c1.16.34 2.33.67 3.5 1 1.68.44 3.38.8 5 1.28s3.08 1.05 4.63 1.52 3.08.84 4.62 1.27c1.78.5 3.55 1 5.33 1.53 1.06.29 2.15.48 3.22.71",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path28",
    d: "M303.41 344.75c-1-2.48-2.1-4.94-3.07-7.43-.77-2-1.35-4-2.13-6s-1.79-4-2.64-6-1.46-3.85-2.26-5.74c-1.13-2.68-2.38-5.31-3.47-8s-2.08-5.51-3.1-8.26a27.4 27.4 0 00-1-2.66 67.54 67.54 0 01-3-7.14c-1.14-3.19-2.56-6.28-3.89-9.4-.81-1.92-1.71-3.82-2.5-5.75s-1.4-4-2.29-5.86a20.3 20.3 0 00-1.55-3.45c-.49-.69-.55-1.84-1-2.76a32.06 32.06 0 01-1.44-3.76c-.88-2.25-1.74-4.5-2.67-6.72-.64-1.52-1.39-3-2.09-4.49",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path29",
    d: "M223 145.76c-.84.23-1.28.9-1.85 1.51-2.59 2.78-5.33 5.41-8 8.17-4 4.21-7.91 8.52-11.93 12.73s-8.13 8.31-12.17 12.49q-7.32 7.53-14.57 15.13c-3.51 3.7-6.88 7.51-10.4 11.19s-7.09 7.2-10.63 10.81c-1 1-2 2.15-2.95 3.22",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path30",
    d: "M259.83 366.75c-3.13 2.33-6.27 4.65-9.39 7s-6 4.55-9 6.87c-2.55 2-5 4-7.58 6-3 2.31-6 4.59-9 6.87-4.8 3.65-9.64 7.26-14.42 10.95-2.71 2.08-5.3 4.32-8 6.42-3 2.38-6.17 4.66-9.24 7s-6.36 5-9.53 7.42l-3.67 2.99",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path31",
    d: "M98.81 224.93c1.45.52 2.9 1 4.35 1.54 1.63.57 3.26 1.15 4.91 1.68.87.28 1.77.47 2.65.71 1.69.46 3.38.89 5 1.41 1.46.46 2.89 1 4.35 1.53.36.12.75.17 1.11.28 1.73.51 3.46 1 5.19 1.54s3.38.89 5 1.42c.818.32 1.616.687 2.39 1.1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path32",
    d: "M135.67 236.7c2.35.22 4.49 1.21 6.73 1.83 1.63.45 3.27.92 4.9 1.4 1.17.35 2.34.74 3.5 1.12 2.57.84 5.14 1.7 7.71 2.52 3.13 1 6.25 2 9.39 2.93 2.56.76 5.14 1.41 7.71 2.12.75.21 1.49.46 2.24.7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path33",
    d: "M316.45 186c-1.36.93-2.7 1.88-4.07 2.79s-2.88 1.91-4.35 2.81c-2.18 1.33-4.4 2.59-6.58 3.93-3 1.85-6 3.77-9 5.59s-5.82 3.32-8.68 5.07c-3.17 2-6.24 4.05-9.4 6-2.53 1.56-5.16 3-7.69 4.51-2.19 1.34-4.29 2.83-6.47 4.18-2.54 1.58-5.14 3.07-7.69 4.64s-5.26 3.24-7.85 4.91c-2.41 1.55-4.77 3.17-7.15 4.75",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path34",
    d: "M157.39 273.56a4.76 4.76 0 00-2.86.76c-1 .68-2.47.71-3.72 1.07s-2.72.82-4.07 1.26c-1.82.59-3.65 1.18-5.46 1.82-1.33.47-2.62 1-3.93 1.53-.93.35-1.86.69-2.8 1-2.52.77-5.07 1.44-7.56 2.27s-4.86 1.79-7.3 2.63c-1.42.49-2.9.82-4.34 1.28-1.64.53-3.26 1.15-4.91 1.67-2.32.73-4.69 1.33-7 2.13s-4.58 1.78-6.88 2.62c-1 .37-2.06.55-3.08.87-2.53.77-5 1.56-7.56 2.39a5.47 5.47 0 00-1.13.68",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path35",
    d: "M327.52 180a5.81 5.81 0 01-.73 1.8c-2.47 2.71-5 5.33-7.54 8-3.15 3.39-6.25 6.82-9.4 10.21-1.08 1.16-2.25 2.23-3.35 3.38-2.72 2.83-5.42 5.7-8.13 8.54-3.08 3.23-6.18 6.43-9.25 9.67-4.26 4.52-8.49 9.07-12.76 13.59-3.76 4-7.56 7.94-11.34 11.91",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path36",
    d: "M278.05 162.43c-1.91.7-3.63 1.8-5.58 2.46-2.58.87-5 2.3-7.46 3.41-1.17.52-2.43.83-3.63 1.29-1 .38-2 .82-2.95 1.25-2.71 1.21-5.42 2.44-8.13 3.64-1.21.54-2.43 1-3.64 1.55-1.78.75-3.56 1.47-5.33 2.24s-3.72 1.71-5.61 2.51c-1.1.47-2.24.83-3.35 1.28-1 .39-1.88.83-2.81 1.26a51.92 51.92 0 01-5.76 2.6c-2.21.7-4.2 1.81-6.3 2.71-3.48 1.49-7 2.91-10.5 4.35",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path37",
    d: "M203.36 196.77c-1 2.33-2.11 4.65-3.07 7-1.09 2.68-2 5.43-3.12 8.11-.75 1.86-1.71 3.64-2.49 5.48s-1.39 3.65-2.12 5.46c-.86 2.11-1.79 4.2-2.65 6.31-.78 1.9-1.43 3.86-2.27 5.73a24.5 24.5 0 01-1.64 3.84 14.27 14.27 0 00-1.18 3.19 30.73 30.73 0 01-1.13 2.94c-.54 1.15-1.2 2.24-1.81 3.37",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path38",
    d: "M299.35 129.64a5.41 5.41 0 01-1.12.41c-2.38.35-4.78.61-7.15 1-2.9.5-5.79 1.14-8.69 1.66s-5.7.9-8.54 1.42c-2.54.46-5.05 1-7.58 1.52-.68.13-1.41 0-2.09.16-3.14.58-6.26 1.25-9.4 1.8s-6.08.89-9.1 1.43c-2.4.43-4.76 1.06-7.15 1.5-1.34.25-2.71.28-4.06.45-1.6.21-3.19.4-4.76.73a5.4 5.4 0 00-1.55 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path39",
    d: "M179 386.65a4 4 0 01-.64 2.42 11.64 11.64 0 00-1 3.18c-.75 2.52-1.46 5.06-2.25 7.57s-1.69 4.94-2.51 7.43c-.42 1.29-.75 2.61-1.13 3.92-.11.38-.3.74-.41 1.12-.52 1.73-1 3.46-1.55 5.19a82.65 82.65 0 01-1.12 3.36c-.54 1.5-1.14 3-1.67 4.49-.29.82-.45 1.68-.72 2.51-.78 2.48-1.58 5-2.36 7.44a2.27 2.27 0 000 .69",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path40",
    d: "M157.11 87.46c-.09 1.4-.17 2.81-.28 4.21-.17 2-.44 4-.54 6-.16 3-.67 9.24-.76 12.24",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path41",
    d: "M232.36 237.69c-.49 1.42-1.85 1.89-2.94 2.66-3.41 2.38-6.81 4.78-10.23 7.14-2.88 2-5.8 3.92-8.69 5.89-1.55 1.06-3.08 2.15-4.62 3.22",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path42",
    d: "M198.73 256.88a13.22 13.22 0 01-2.66.54c-10 0-20.09-.07-30.13-.12-8.27 0-16.54-.1-24.81-.13h-12.47c-7.61 0-15.23-.09-22.84-.14a8.57 8.57 0 01-1.12-.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path43",
    d: "M241.61 362.26a57.06 57.06 0 01-7.15-1.79c-1.79-.54-3.64-.85-5.46-1.29-1.59-.4-3.18-.83-4.76-1.26-1.83-.5-3.65-1-5.47-1.54s-3.83-1.13-5.75-1.68c-1.3-.38-2.6-.8-3.92-1.11-1.95-.47-3.92-.85-5.88-1.28a3.59 3.59 0 01-.43-.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path44",
    d: "M194.53 351.33c-.66.13-1.328.22-2 .27-4.81.16-9.62.33-14.43.43-8.27.16-16.54.28-24.8.43-2.57 0-5.14.08-7.71.14-.376.026-.75.073-1.12.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path45",
    d: "M134.83 353l-4.91.56",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path46",
    d: "M122.5 355c-1.36.46-2.72.92-4.07 1.4-1.5.55-3 1.1-4.48 1.68-2.48 1-4.94 2-7.43 2.93-1.09.41-2.26.61-3.35 1a17.63 17.63 0 00-2.11 1.1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path47",
    d: "M152.63 112.69a10.52 10.52 0 01-1.4-.29c-1.32-.49-2.62-1-3.93-1.54l-2.8-1.11c-2.38-.94-4.78-1.85-7.15-2.82-1.74-.71-3.43-1.54-5.19-2.21a37.9 37.9 0 00-4-1.64 45.09 45.09 0 01-5.77-2.44c-1.15-.49-2.33-1-3.5-1.4-.88-.34-1.78-.63-2.66-1-2-.82-3.91-1.7-5.89-2.51s-3.84-1.46-5.74-2.26-3.92-1.77-5.89-2.65c-.78-.35-1.57-.69-2.38-1-2-.72-4-1.35-6-2.13-.7-.28-1.17-1.18-2.12-.68",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path48",
    d: "M195.51 350.91a2 2 0 00-2.1-1.29c-.52 0-1-.39-1.55-.52-2-.49-4-.9-6-1.42s-3.92-1.13-5.89-1.66-3.75-.9-5.6-1.43c-1.6-.45-3.17-1-4.77-1.51-.49-.14-1.05 0-1.54-.17-2-.57-4-1.22-6-1.8-1.11-.32-2.23-.58-3.36-.84-1.82-.43-3.65-.81-5.46-1.28s-3.46-1-5.19-1.54c-.15 0-.27-.23-.42-.26-1.59-.34-3.19-.59-4.76-1-2-.53-4-1.23-6-1.79-1.53-.43-3.08-.76-4.62-1.13l-3.37-.84",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path49",
    d: "M243.71 364.09a13.2 13.2 0 01-1.82 1q-3.63 1.24-7.29 2.39c-2.74.87-5.51 1.69-8.26 2.53-1.26.38-2.53.73-3.78 1.13-1.83.58-3.65 1.2-5.47 1.82-1.36.45-2.7.95-4.07 1.39q-2.51.81-5 1.54c-2 .58-4 1.1-6 1.7-1.37.41-2.71.95-4.07 1.38-1.68.54-3.37 1-5 1.56-1.46.48-2.89 1.06-4.35 1.52s-3 .86-4.48 1.27c-.37.11-.75.19-1.12.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path50",
    d: "M180.93 382.58c1.83-2.94 3.62-5.9 5.48-8.82 2.26-3.57 4.61-7.08 6.84-10.66 1.43-2.29 2.71-4.68 4.09-7 .5-.83 1.11-1.59 1.67-2.38",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path51",
    d: "M134 237c-.33.62-.85.73-1.53.88-2 .44-4 1.09-6 1.63-1.77.49-3.55.92-5.32 1.41-1.6.45-3.18 1-4.77 1.39-1.77.5-3.56.91-5.32 1.42s-3.28 1-4.91 1.54c-.15.05-.29.28-.42.26-1.87-.27-3.38 1-5.18 1.18a21.81 21.81 0 00-3.93.94c-2.29.63-4.59 1.27-6.86 2-1.61.5-3.16 1.19-4.78 1.65s-3.36.73-5 1.16c-.73.18-1.38.63-2.11.8-1.76.43-3.57.7-5.31 1.18-.59.17-1 .8-1.55 1.22",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path52",
    d: "M223.54 147.16q-1 2.44-2 4.91c-.66 1.67-1.28 3.37-2 5-.57 1.41-1.24 2.79-1.8 4.21-.74 1.85-1.39 3.74-2.12 5.59-.42 1.05-1 2.05-1.39 3.09-1.23 3.08-2.4 6.18-3.66 9.25-.78 1.89-1.71 3.72-2.5 5.61-.89 2.13-1.69 4.29-2.53 6.44",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path53",
    d: "M119.27 340.12c.28.1.72.11.82.3 1.72 3.06 3.36 6.17 5.1 9.22.27.46 1.11.6.81 1.41",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path54",
    d: "M129.22 359c.24.56.49 1.11.69 1.69.07.2 0 .48 0 .69 1 2.95 1.92 5.9 2.95 8.83.84 2.4 1.82 4.75 2.63 7.16.49 1.45.7 3 1.16 4.47s1.05 2.7 1.51 4.07.81 2.81 1.28 4.2 1.13 3 1.67 4.49q.68 1.88 1.26 3.78c.4 1.3.71 2.63 1.14 3.92s1.05 2.79 1.52 4.21.85 2.89 1.27 4.34c.19.65.37 1.31.56 2",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path55",
    d: "M197.33 314.62c-3.13.42-6.27.76-9.39 1.28-3 .5-5.88 1.22-8.83 1.79-.82.15-1.68.07-2.52.17a16.43 16.43 0 00-1.82.4",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path56",
    d: "M173.23 318.54c-3.23.42-6.46.8-9.67 1.29-1.24.18-2.41.75-3.65.93-2.84.41-5.79.34-8.52 1.1s-5.58.69-8.3 1.42c-1 .28-2.16.23-3.21.48-.42.1-1.22-.24-1.27.67",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path57",
    d: "M167.34 117c1.33.46 2.41 1.41 3.91 1.63a13.21 13.21 0 012.24 1.07c2.52 1.07 4.94 2.36 7.45 3.45 1.83.79 3.94 1.12 5.52 2.23 1 .72 2.23.79 3.25 1.61 1.33 1.08 3.29 1.38 4.95 2.07 1.24.51 2.43 1.12 3.65 1.67q1.47.66 2.94 1.26c1.77.72 3.58 1.35 5.32 2.12 2 .87 3.83 1.88 5.76 2.78a50.86 50.86 0 015.9 2.64 18.64 18.64 0 003.34 1.29",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path58",
    d: "M123.06 354a5.77 5.77 0 00-1.68-.54c-5.14 0-10.28 0-15.42.14-3.08.07-6.16.36-9.25.53-1.49.08-3 .1-4.48.15",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path59",
    d: "M89.42 354.14c-1.82.42-3.63.86-5.46 1.25-2.52.54-5 1-7.57 1.55l-7.85 1.54-.56.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path60",
    d: "M59.16 359.18l-2.67-.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path61",
    d: "M54.67 358.62l-6.87-.56-8.26-.7c-1.36-.12-2.71-.28-4.07-.42",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path62",
    d: "M33.65 356.66q-2.41-.75-2.1 1.68c.47 3.64.9 7.29 1.41 10.93.31 2.16.74 4.3 1.11 6.45",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path63",
    d: "M34.07 375.86l1.26 7.84",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path64",
    d: "M221.85 144.36l-4.34 1.82c-1.82.75-3.65 1.47-5.46 2.25-2 .86-4 1.79-6 2.65-2.51 1-5.06 2-7.56 3.1-1.29.54-2.51 1.26-3.8 1.79-1.84.76-3.74 1.4-5.59 2.13-.82.32-1.59.76-2.39 1.11-2.24.94-4.5 1.85-6.72 2.81-3.19 1.38-6.36 2.81-9.54 4.19-.87.38-1.77.66-2.66 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path65",
    d: "M280.15 164l-2.94 4.62c-.79 1.22-1.61 2.42-2.38 3.65-1.19 1.9-2.32 3.84-3.52 5.74-1 1.65-2.17 3.25-3.2 4.91-1.85 3-3.61 6-5.49 8.95-1.48 2.33-3.1 4.57-4.6 6.89-1.31 2-2.53 4.1-3.79 6.15q-2.67 4.35-5.33 8.69c-.76 1.26-1.5 2.53-2.24 3.79",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path66",
    d: "M158.09 274.54q-6 7-11.91 14-7.52 8.88-15 17.79c-1.94 2.32-3.83 4.68-5.75 7q-5.18 6.24-10.37 12.47",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path67",
    d: "M271.46 206.16l-2.52 1.26c-3.83 1.87-7.67 3.71-11.49 5.61-3.19 1.6-6.35 3.26-9.53 4.9",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path68",
    d: "M243 220.17l-6.86 3.36c-1.5.74-3 1.51-4.49 2.24-1.77.86-3.56 1.66-5.32 2.54-1 .5-2 1.14-3 1.66s-1.87.85-2.8 1.27c-.7.32-1.41.64-2.1 1-1.5.74-3 1.52-4.49 2.24-1.81.86-3.65 1.67-5.46 2.53-1.5.72-3 1.49-4.48 2.24l-5 2.5c-2.24 1.12-4.53 2.16-6.7 3.4-1 .54-2.44.34-2.83 1.78",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path69",
    d: "M229 143.38a4.54 4.54 0 002.8 1.29 14.55 14.55 0 013.63 1 42.35 42.35 0 005.75 2c2.33.66 4.58 1.6 6.88 2.34 1.52.49 3.1.8 4.62 1.29s2.71 1 4.07 1.52c1.12.43 2.22.91 3.36 1.25 2.47.75 5 1.37 7.42 2.13 1.53.48 3 1.16 4.5 1.65s3.09.83 4.61 1.3a9.23 9.23 0 011.55.82",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path70",
    d: "M163.7 167.34c-3.32-2.1-6.53-4.41-10-6.25-3.89-2.09-7.6-4.45-11.32-6.78-2.62-1.64-5.22-3.3-7.86-4.9s-5.22-3.09-7.84-4.63l-10.23-6c-.67-.4-1.31-.84-2-1.26",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path71",
    d: "M263.61 251.7c-.09 1.63-.18 3.27-.28 4.9",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path72",
    d: "M263.05 259c-.18 1.58-.39 3.17-.55 4.76-.25 2.43-.47 4.86-.71 7.29-.12 1.17-.28 2.33-.42 3.5",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path73",
    d: "M261.09 276.36c-.23 2.43-.45 4.86-.7 7.29-.31 2.94-.65 5.89-1 8.83",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path74",
    d: "M259.13 294c-.09 1.73-.19 3.46-.28 5.18",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path75",
    d: "M164.54 119c0 4.77.07 9.53.15 14.3 0 2.43.17 4.85.27 7.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path76",
    d: "M165.24 153.61v5.74",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path77",
    d: "M260.81 303.83c1.59 1.59 3.19 3.17 4.76 4.76q4.57 4.62 9.11 9.25 12.27 12.48 24.53 25a22.09 22.09 0 012.08 2.25 2.32 2.32 0 002.12 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path78",
    d: "M86.48 88.86c.42.94.78 1.91 1.27 2.8q3.25 5.91 6.59 11.77c1 1.84 2 3.77 3 5.56.95 1.58 1.78 3.23 2.69 4.82 1 1.8 1.94 3.66 3 5.46 1.17 2 2.47 4 3.61 6 .8 1.44 1.39 3 2.14 4.47.39.78.94 1.48 1.38 2.25.27.49.47 1 .71 1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path79",
    d: "M64.62 111l.28.7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path80",
    d: "M64.9 111.85c.23 2 .48 4 .7 6 .29 2.71.24 5.51.92 8.11 1 3.62.51 7.38 1.56 11a27 27 0 01.34 4.05c.48 3.79 1.06 7.57 1.5 11.36.22 1.85.21 3.73.31 5.6",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path81",
    d: "M129.78 354.56c1.41.93 2.78 1.9 4.21 2.79s3.07 1.81 4.63 2.66a27.1 27.1 0 014 2.16 47 47 0 005 3.16c2.82 1.78 5.68 3.49 8.54 5.2 4 2.35 8 4.58 11.88 7.06 1.38.88 2.78 1.86 4.16 2.63 2.13 1.19 4.16 2.51 6.24 3.76",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path82",
    d: "M162.58 169.44c-2 .94-4 1.9-6 2.79-1 .44-2 .74-3.07 1.14s-1.79.72-2.66 1.12c-2.72 1.25-5.39 2.59-8.14 3.76-3.24 1.39-6.56 2.57-9.79 4-2.61 1.12-5.12 2.48-7.73 3.61-1.87.81-3.83 1.39-5.73 2.13-1.15.45-2.24 1-3.37 1.52-.73.32-1.49.57-2.24.85",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path83",
    d: "M283.65 161.59c3.13 1 6.25 2.09 9.4 3.08 2.41.75 4.87 1.36 7.27 2.13 1.48.46 2.9 1.12 4.36 1.65.87.32 1.76.59 2.66.85 2.61.75 5.24 1.46 7.84 2.26 1.2.37 2.33.95 3.51 1.37.58.21 1.23.25 1.82.44 1.5.49 3 1 4.48 1.54l4.49 1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path84",
    d: "M208.68 260c.33.09.8.08 1 .29 1.39 1.92 3.6 2.6 5.49 3.77l5.18 3.22c2.8 1.73 5.6 3.48 8.42 5.18.94.57 2 1 2.93 1.55",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path85",
    d: "M234.19 280.85c-.1 1.87-.23 3.73-.28 5.6-.16 5.93-.26 11.87-.43 17.8-.16 5.6-.3 11.21-.61 16.81-.07 1.4.39 3-.79 4.21",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path86",
    d: "M202.09 317.14c2.25 2.29 4.5 4.57 6.73 6.87 2.07 2.14 4.13 4.27 6.16 6.45 3.43 3.67 6.8 7.4 10.25 11.06 2.47 2.61 5.07 5.11 7.55 7.72 3 3.19 6 6.44 9 9.66.388.387.795.754 1.22 1.1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path87",
    d: "M66.72 108.62c2.38 1.4 4.78 2.78 7.15 4.21q3.87 2.36 7.7 4.77c2.44 1.52 4.83 3.13 7.3 4.6s4.88 2.68 7.27 4.09 4.57 2.91 6.88 4.33c1.89 1.16 3.84 2.23 5.74 3.38.493.335.961.706 1.4 1.11",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path88",
    d: "M87.74 88c3.79 3.41 7.54 6.86 11.36 10.22s8 6.81 11.9 10.25c3.76 3.28 7.46 6.65 11.22 9.94 2.4 2.09 4.85 4.11 7.28 6.17",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path89",
    d: "M303 130.2q2.31 3.72 4.63 7.43c1 1.55 2 3.07 2.93 4.63 1.38 2.27 2.71 4.58 4.07 6.86l5.19 8.69c2.15 3.6 4.28 7.21 6.45 10.79 1.46 2.4 3 4.76 4.48 7.15",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path90",
    d: "M155.43 116.89c.175.209.314.445.41.7.35 2.43.58 4.88 1 7.28s1.16 4.95 1.65 7.44c.53 2.74.89 5.52 1.43 8.26.48 2.44 1.18 4.85 1.64 7.29s.77 4.95 1.15 7.43c.073.378.167.752.28 1.12.23.89.44 1.78.71 2.66.144.304.33.586.55.84",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path91",
    d: "M231.52 237.27c-1.12.23-2.24.44-3.36.7-1.5.35-3 .73-4.48 1.12-2.44.64-4.87 1.27-7.29 2-1.56.45-3.06 1.11-4.63 1.51-1.85.47-3.75.72-5.6 1.16-1.65.39-3.27.93-4.91 1.38s-3.55.93-5.32 1.41c-.57.15-1.11.41-1.69.55-1.25.3-2.52.57-3.78.85",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path92",
    d: "M317 185.28c-.94-.84-1.93-.39-2.79 0a18.73 18.73 0 01-3.23 1.53 18.47 18.47 0 00-2.36 1.17c-2.93 1.31-5.71 3-8.59 4.4s-5.8 2.69-8.67 4.09c-1.67.82-3.25 1.82-4.92 2.64-2.87 1.4-5.8 2.69-8.67 4.09-1 .5-2 1.2-3 1.8",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path93",
    d: "M75.27 300.75c0 1.76-1.69 1.82-2.69 2.47a52.67 52.67 0 01-5.16 2.71c-1.6.81-3.24 1.55-4.83 2.39-2.14 1.13-4.23 2.38-6.38 3.48s-4.49 2.14-6.72 3.25c-1.33.66-2.61 1.41-3.93 2.09-2.42 1.23-4.88 2.39-7.27 3.66a29.52 29.52 0 00-2.82 1.95",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path94",
    d: "M60.28 304.39a2.88 2.88 0 01-1.81.9c-1.91.39-3.75 1.06-5.62 1.62-1.54.47-3.07 1-4.63 1.39s-3.19.69-4.75 1.15-2.79 1.08-4.22 1.51c-1.66.49-3.36.84-5 1.28-1.17.31-2.34.63-3.5 1q-2.75.76-5.51 1.66l-4.34 1.4",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path95",
    d: "M19.14 317.06c.28-.75.08-5.2.36-5.94",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path96",
    d: "M153.33 111.29c-1.4-1.59-2.89-3.12-4.19-4.78-2-2.61-3.91-5.34-5.91-8-2.87-3.76-5.79-7.48-8.68-11.22-1.92-2.47-3.82-5-5.75-7.42a2.43 2.43 0 00-2.8-1.03c-2.93.67-6 .9-9 1.34-2.76.4-5.52.81-8.27 1.26-3.67.62-7.35 1.22-11.06 1.57-1.75.16-3.46.83-5.19.89a15.52 15.52 0 00-5.19 1.18",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path97",
    d: "M58.87 303.13l-3.5.56a15.48 15.48 0 00-4 .76c-2 1-4.28.75-6.35 1.46a21.57 21.57 0 01-2.79.58",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path98",
    d: "M40.66 306.77c-.1.09-.18.25-.28.27-2.06.39-4.12.74-6.17 1.14-.71.14-1.4.39-2.1.55s-1.5.27-2.24.43c-1.27.27-2.53.55-3.79.84-1.59.36-3.16.8-4.77 1.09a2.31 2.31 0 01-1.7-.3c-.54-.48 0-1.06.26-1.66a36.63 36.63 0 001.31-4c.31-1 .62-2 1-2.94.52-1.37 1.17-2.69 1.65-4.07.35-1 .78-2 1-3 .35-1.41 2.79-9 3.19-10.31",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path99",
    d: "M66.3 259.27c1.5 2.18 2.15 4.72 3.09 7.14.34.89.67 1.84 1.06 2.62 1.14 2.24 1.93 4.6 2.87 6.91.78 1.89 1.73 3.71 2.49 5.61s1.36 3.95 2.14 5.88 1.77 3.92 2.64 5.89c.32.73.57 1.49.85 2.24",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path100",
    d: "M81.16 301c-1 2.28-1.94 4.59-3 6.86-.44 1-1 1.87-1.53 2.81",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path101",
    d: "M76.11 312.24l-2.38 6c-.31.76-.65 1.5-1 2.24",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path102",
    d: "M76.11 311.4a4.6 4.6 0 00-1.39 0c-1.84.56-3.66 1.17-5.47 1.8-1.27.44-2.52.95-3.79 1.39s-2.33.78-3.5 1.13c-2.43.71-4.88 1.34-7.28 2.12-1.53.5-3 1.28-4.5 1.78s-3 .71-4.47 1.17c-1.07.33-2.1.76-3.22 1-1.45.33-2.78 1.19-4.23 1.58a11.44 11.44 0 01-2.93.05",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path103",
    d: "M205.74 194.81c2.24 1.49 4.39 3.14 6.75 4.44 2.69 1.48 5.3 3 7.85 4.76 2.3 1.55 4.87 2.69 7.25 4.12 3.45 2.09 6.83 4.29 10.24 6.43 1.86 1.18 3.74 2.34 5.6 3.51",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path104",
    d: "M104.56 394.77a15.45 15.45 0 00-5.9 1 7.91 7.91 0 01-2.09.18 85.63 85.63 0 00-9.51 1.05 62.15 62.15 0 01-6.88 1c-3 .31-6 1-9 1.48-.69.11-1.4.1-2.11.15",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path105",
    d: "M273.42 398.42c-.23 2.17.68 4.07 1.39 6 .5 1.37.85 2.8 1.28 4.2.93 3 1.9 6 2.78 9 .51 1.71.86 3.45 1.28 5.18",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path106",
    d: "M303.13 349.79c-1.45.56-2.89 1.13-4.34 1.68s-3 1.13-4.49 1.68c-1.16.43-2.33.86-3.5 1.26s-2.53.84-3.78 1.27c-1.59.55-3.19 1.1-4.77 1.68-2.2.82-4.38 1.71-6.59 2.51s-4.3 1.49-6.44 2.26c-1.32.48-2.62 1-3.92 1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path107",
    d: "M263.33 367.45c.47 1.54.93 3.09 1.41 4.62s1.07 3.17 1.52 4.77.83 3.37 1.29 5c.27 1 .62 2 1 2.94.55 1.5 1.19 3 1.66 4.5s.75 3 1.15 4.47c.34 1.27.74 2.53 1.11 3.79",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path108",
    d: "M110.45 137.49c-1.22 1-2.39 2.11-3.66 3.07a203.72 203.72 0 01-6.58 4.77c-2.78 1.95-5.62 3.8-8.4 5.76-2.23 1.59-4.36 3.31-6.6 4.89-4.08 2.88-8.21 5.71-12.32 8.56",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path109",
    d: "M66.72 201.11a4.82 4.82 0 003.22 1.18c1.74.11 3.45.66 5.19.91 2.317.27 4.613.7 6.87 1.29 2.48.7 5 .65 7.51 1.56 2.3.86 4.92.84 7.39 1.23a17 17 0 012.66.58c1.42.48 3 .06 4.38.9a1.35 1.35 0 002-.91c.89-2.46 1.9-4.89 2.93-7.29.82-1.94 1.78-3.83 2.64-5.76.42-1 .75-2 1.13-2.94",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path110",
    d: "M235.87 239.37c-.1 1.63-.21 3.27-.28 4.9-.29 7-.59 13.92-.83 20.88-.08 2.29 0 4.58 0 6.87",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path111",
    d: "M70.79 373.9c-.75.23-1.5.45-2.24.7-1.22.41-2.44.83-3.65 1.26-1.4.5-2.81 1-4.2 1.54s-2.8 1.14-4.21 1.67-2.62.93-3.92 1.41-2.71 1-4.07 1.54c-1.16.43-2.34.83-3.5 1.27-1.45.54-2.89 1.14-4.35 1.67-.68.24-1.39.38-2.09.57",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path112",
    d: "M114.09 191.86c2.38 2.06 4.78 4.1 7.14 6.17 3.29 2.88 6.53 5.81 9.82 8.68q6.84 6 13.73 11.91c1 .87 2.05 1.69 3.08 2.53",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path113",
    d: "M177.71 386.93c-1.82 1.73-3.68 3.42-5.46 5.19l-15 15c-.21.21-.47.37-.7.57s-.52.46-.77.7l-6.24 6",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path114",
    d: "M96.57 366.05c-3 3.17-6 6.34-9 9.53q-6 6.5-12.06 13L67.84 397",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path115",
    d: "M126 356.8c-.61 1.07-1.27 2.12-1.81 3.23-1.25 2.55-2.44 5.13-3.65 7.7-.71 1.49-1.41 3-2.11 4.48-.75 1.64-1.47 3.28-2.24 4.91-.87 1.83-1.78 3.64-2.66 5.46-1.13 2.34-2.23 4.68-3.37 7-.47 1-1 1.87-1.54 2.8",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path116",
    d: "M108.34 328.35a5 5 0 01-1.4.82c-2.09.39-4.2.71-6.31 1-1.44.2-2.9.22-4.34.45-3.09.51-6.15 1.18-9.25 1.64-2.84.43-5.7.67-8.54 1a10.74 10.74 0 00-1.55.41",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path117",
    d: "M73 330.73l-.28-1.26",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path118",
    d: "M72.47 327.37l-.28-4.62",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path119",
    d: "M73.17 322.19c1.07.18 2.14.41 3.22.55 2.8.35 5.62.58 8.41 1 3.37.52 6.72 1.24 10.09 1.79 3.54.57 7.1 1 10.65 1.57.687.163 1.356.39 2 .68",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path120",
    d: "M127.4 367.17c-.05 3.18-.12 6.35-.13 9.53v13.31c0 .79.12 1.59.12 2.38 0 1.4-.28 1.68-1.67 1.68h-14.57a10.86 10.86 0 00-1.13.13",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path121",
    d: "M33.23 228.44l30.83.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path122",
    d: "M97.27 225.35c0 1.28-.92 1.92-1.69 2.66q-4.17 4-8.4 8-6.18 5.82-12.47 11.63c-2 1.91-4.13 3.81-6.15 5.76a5.15 5.15 0 00-.72 1.38",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path123",
    d: "M67.84 322.75c-1.68 0-3.37 0-5 .15-2.76.22-5.51.55-8.27.83a3.82 3.82 0 00-.56.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path124",
    d: "M52.43 324.15c-1.68.14-3.37.22-5 .43-2.11.27-4.2.69-6.31.95-1.49.18-3 .21-4.49.3",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path125",
    d: "M63.5 255.06l-11.63-9.53c-3.73-3-7.48-6.06-11.21-9.11-2-1.66-4-3.4-6-5a8.22 8.22 0 00-2.22-.87",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path126",
    d: "M260.67 366.75c.2 2-1.23 3.31-2 4.89-1.16 2.43-2.46 4.79-3.76 7.15-1.17 2.13-2.48 4.18-3.63 6.32-2 3.76-3.91 7.57-5.91 11.34-.4.76-1 1.39-1.51 2.12a8.9 8.9 0 00-.58 1.25",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path127",
    d: "M56.63 126.14c.28.14.74.22.82.43.83 2.23 1.61 4.48 2.41 6.72q.6 1.68 1.26 3.36c.4 1 .9 2 1.25 3.09.74 2.23 1.39 4.48 2.12 6.72.32 1 .77 1.95 1.1 2.94a51.4 51.4 0 001.9 5.57 16 16 0 011 2.68c.15.52.88.86 1.35 1.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path128",
    d: "M70.65 334.24a24.86 24.86 0 01-2.53.68c-2.51.42-5 .79-7.56 1.13-2.9.4-5.81.67-8.69 1.15-3 .51-6.06 1.26-9.12 1.75a7.25 7.25 0 01-2.51-.51",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path129",
    d: "M83.82 299.2c2 2 3.9 4 5.89 6q7.68 7.65 15.41 15.27c2 1.95 4 3.83 6 5.75",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path130",
    d: "M178.83 248.9c-.88-1.93-2.73-2.88-4.21-4.2-6.38-5.63-12.8-11.21-19.19-16.83-1.48-1.31-2.9-2.7-4.35-4.06",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path131",
    d: "M111 190.74a11.89 11.89 0 01-2.25 1c-2.42.49-4.86.83-7.28 1.29s-5 1-7.57 1.53l-9.39 1.83-1.4.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path132",
    d: "M257.59 302.71c-1.4 1.26-2.88 2.45-4.19 3.79-4.71 4.83-9.36 9.7-14 14.57-1.63 1.71-3.21 3.46-4.85 5.17a2.89 2.89 0 01-.9.43",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path133",
    d: "M233.2 277.76c-.7.8-1.44 1.56-2.09 2.39-2.49 3.21-5 6.45-7.44 9.66-1.2 1.55-2.15 3.28-3.74 4.53a1.8 1.8 0 00-.28 1.63c1.09 2.78 2.34 5.51 3.45 8.28.82 2 1.46 4.13 2.27 6.16s1.72 3.81 2.49 5.76c.56 1.41.87 2.92 1.44 4.33.66 1.62 1.48 3.18 2.22 4.77",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path134",
    d: "M75.27 372.77a21.7 21.7 0 016.86-3 21.83 21.83 0 002.67-1c1.21-.43 2.43-.82 3.64-1.26 1.36-.5 2.72-1 4.06-1.55.91-.37 1.78-.83 2.67-1.25",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path135",
    d: "M99.65 367.45l1.41 4.9c.37 1.31.7 2.63 1.13 3.92s1.08 2.7 1.51 4.08c.8 2.55 1.38 5.18 2.32 7.68a23.91 23.91 0 01.92 3.66",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path136",
    d: "M234.47 333.26c.7 1.63 1.43 3.25 2.09 4.91.39 1 .63 2.06 1 3.07.43 1.23.92 2.44 1.39 3.65q.83 2.1 1.68 4.2c.41 1 .86 2 1.26 3 .85 2.09 1.7 4.19 2.51 6.31.147.5.247 1.012.3 1.53",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path137",
    d: "M260.81 246.93a22.14 22.14 0 00-5.45-2.41 23.52 23.52 0 01-3.24-1.65",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path138",
    d: "M250.72 243.57c-1.4 2.66-2.85 5.3-4.19 8-2.05 4.14-4 8.32-6.05 12.47-1.11 2.26-2.34 4.48-3.48 6.73a8.12 8.12 0 00-.43 1.4",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path139",
    d: "M129.36 127.26a50.58 50.58 0 01-7.14 3.94c-1.34.62-2.62 1.38-3.93 2.09s-2.33 1.3-3.5 2",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path140",
    d: "M112.55 139c0 7.38.1 14.76.13 22.14v11.63c.022.472.069.943.14 1.41",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path141",
    d: "M112.83 176.87v3.78",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path142",
    d: "M68.54 323.17c-.75 1.4-2.33 1.6-3.52 2.35-.8.51-1.79.71-2.63 1.16-1.57.84-3 1.86-4.65 2.63-2.2 1.07-4.51 1.91-6.7 3s-4.48 2.43-6.75 3.61c-1 .54-2.14.94-3.21 1.41",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path143",
    d: "M35.75 338.86q-3.57-4.69-7.15-9.38a7.8 7.8 0 00-.7-.71",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path144",
    d: "M191.3 261.93c-.28 0-.65-.12-.82 0-1.62 1.26-3.64 1.44-5.48 2.08q-3.65 1.28-7.29 2.52c-1 .35-2.06.64-3.08 1-2.9 1-5.77 2-8.7 2.9-1.359.316-2.64.9-3.77 1.72",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path145",
    d: "M261.79 250c-2 2-3.88 4-5.89 5.87-3.05 2.89-6.16 5.71-9.24 8.56-2.72 2.52-5.4 5.07-8.15 7.55a6.81 6.81 0 01-1.8.86",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path146",
    d: "M52.71 281.27c2.29 1.26 4.58 2.51 6.86 3.78 1.23.69 2.44 1.4 3.65 2.1 2.66 1.54 5.33 3.07 8 4.63a14.9 14.9 0 002.78 1.76 22.39 22.39 0 013.9 2.17c.81.44 1.59.93 2.39 1.39",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path147",
    d: "M67.7 359.6c.82.92 2 .43 3 .69a15.5 15.5 0 001.54.29",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path148",
    d: "M73.73 360.86c2 .19 4 .34 6 .57 2.9.34 5.8.74 8.69 1.11",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path149",
    d: "M90 362.82a22.08 22.08 0 002.8.26 6.12 6.12 0 013.36.73",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path150",
    d: "M208 266.69c.61 1.54 1.19 3.1 1.83 4.62.47 1.1 1 2.15 1.53 3.23.4.92.77 1.86 1.12 2.8.76 2.06 1.47 4.13 2.26 6.16.44 1.15 1.06 2.23 1.52 3.38s.83 2.67 1.44 3.9.5 2.94 1.93 3.8",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path151",
    d: "M61.26 217.51c.65 1.44 1.31 2.89 2 4.34",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path152",
    d: "M66.44 231.66a1.69 1.69 0 00-.13.42q-.44 11-.85 22",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path153",
    d: "M64.34 259c-.93 1.68-1.9 3.34-2.79 5.05-.75 1.44-1.37 3-2.12 4.4-1.84 3.5-3.72 7-5.61 10.44-.333.498-.704.97-1.11 1.41",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path154",
    d: "M236 277.48c3.5 3.69 7 7.36 10.5 11.08 3.16 3.38 6.26 6.82 9.4 10.22.52.55 1.12 1 1.68 1.55",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path155",
    d: "M71.91 375q-6.52 6-13 12.05c-2.13 2-4.22 4-6.31 6-1 .91-1.87 1.86-2.8 2.8",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path156",
    d: "M49.77 396c-.49 1.13.42 1.35 1.12 1.51.91.21 1.92.05 2.79.34a30.66 30.66 0 005.61.84c.86.11 1.67.59 2.53.79a7.85 7.85 0 001.68 0",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path157",
    d: "M198.17 312.8c-3.5-3.6-7-7.19-10.51-10.8q-4.57-4.74-9.1-9.53c-.55-.57-1-1.24-1.57-1.8a4 4 0 00-1.1-.57",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path158",
    d: "M37.43 339.84c.89.84 1.72 1.76 2.68 2.51 2.82 2.19 5.68 4.32 8.54 6.46l9.52 7.19c.82.62 1.59 1.31 2.39 2",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path159",
    d: "M73.31 376.42c-1 2.66-2 5.31-2.93 8-.77 2.26-1.39 4.58-2.13 6.86-.4 1.23-.93 2.43-1.38 3.65-.17.45-.29.93-.43 1.4",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path160",
    d: "M69.24 163l-7.84-8.4c-1.31-1.4-2.61-2.81-3.93-4.21-1.58-1.68-3.18-3.35-4.76-5-1.12-1.2-1.79-1.08-2.22.57a21.93 21.93 0 00-.44 3.35c-.12 1.4-.19 2.8-.28 4.21",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path161",
    d: "M49.49 155c-.14 1.31-.26 2.62-.43 3.92-.31 2.38-.65 4.77-1 7.15",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path162",
    d: "M48.08 171.54c.33 3.37.64 6.73 1 10.09a6.92 6.92 0 00.55 1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path163",
    d: "M52.71 185.7c1.4.88 2.79 1.79 4.21 2.65.81.49 1.53 1.32 2.66 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path164",
    d: "M32.39 231.8c1 2.38 2.1 4.75 3.07 7.15a60 60 0 002.17 5.85c1 2 1.4 4.31 2.69 6.23.55.82.52 2 .76 3.05",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path165",
    d: "M41.08 254.22c1.58 2 2.1 4.41 3.2 6.6s1.47 4.3 2.62 6.33c1 1.75 1.41 3.82 2.18 5.7.55 1.32 1.33 2.55 1.1 4.07a2.92 2.92 0 01-.13.42",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path166",
    d: "M82.14 87.32c-1.54 1.78-3.07 3.57-4.63 5.32q-5 5.63-10.09 11.22c-.6.66-1.21 1.31-1.82 2",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path167",
    d: "M153.05 114.65c-1.48 1.33-3.4 1.91-5.06 2.92s-3.44 1.9-5.17 2.82c-2 1.09-4.12 2.14-6.17 3.23-1.05.57-2.05 1.21-3.08 1.82",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path168",
    d: "M72.47 336.34c-1.08 2.66-2.12 5.34-3.24 8-.83 2-1.79 3.92-2.64 5.9-.74 1.71-1.39 3.46-2.12 5.17a15 15 0 01-1 1.69",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path169",
    d: "M127.26 394.07c4.39 4.58 8.8 9.14 13.17 13.75 1.5 1.58 2.89 3.27 4.36 4.88.305.274.64.512 1 .71",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path170",
    d: "M47.8 206.58c-1.49 1.86-3 3.71-4.47 5.61q-5.56 7.19-11.08 14.43",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path171",
    d: "M74.71 336.06c3.5 4 7.07 7.89 10.48 11.93 1.63 1.93 3.64 3.55 4.8 5.87",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path172",
    d: "M76.67 334.66c1 .47 1.94 1.26 3 1.33a32.09 32.09 0 015.18 1c2.32.53 4.67.94 7 1.43 1 .2 2 .45 2.94.69l2.66.7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path173",
    d: "M29.17 252.82c1 1.31 1.92 2.65 2.95 3.92 1.74 2.13 3.54 4.21 5.31 6.31",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path174",
    d: "M40.24 269.08a34.89 34.89 0 00.45 4.47 46.64 46.64 0 01.84 7.15c.12 1.65.54 3.27.8 4.91a3.67 3.67 0 01-.13 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path175",
    d: "M65.74 166.5l-8.55.84c-1.54.15-3.08.27-4.62.43a13.3 13.3 0 00-1.4.27",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path176",
    d: "M105 209.1c-.27 2.34-1.63 4.28-2.4 6.44s-1.66 4-2.51 6c-.4.94-.84 1.87-1.26 2.8",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path177",
    d: "M94.61 222.55c-2.29-1.59-4.56-3.2-6.87-4.76s-4.67-3.09-7-4.62a3.86 3.86 0 00-.69-.29",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path178",
    d: "M29.73 230.26c-1.69 2.24-3.36 4.49-5.05 6.72-2.33 3.09-4.79 6.09-7 9.28s-4.69 6.25-7 9.37a9.38 9.38 0 00-.56 1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path179",
    d: "M99.51 183.31c-.7-.65-1.35-1.36-2.11-1.94a23.55 23.55 0 00-2.8-1.82 9.15 9.15 0 00-1.67-.58",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path180",
    d: "M86.34 175.89c-1.45.32-2.88.71-4.35 1s-3.08.39-4.62.58",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path181",
    d: "M77.09 178.69c1.17.51 2.33 1.06 3.51 1.53 1.48.6 3 1.17 4.48 1.68 1.15.39 2.34.65 3.5 1 1.55.45 3.08 1 4.63 1.37a4.79 4.79 0 001.54-.12",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path182",
    d: "M23.7 270.48c-.48 1.34-1.91.94-2.8 1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path183",
    d: "M21.74 274.4l4.34 3.6c.489.45 1.006.868 1.55 1.25a2.23 2.23 0 011 3.1 14.85 14.85 0 00-.7 1.82c-.49 1.65-.94 3.32-1.41 5",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path184",
    d: "M33.09 291.36l1 .28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path185",
    d: "M36.17 291.64h3.51",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path186",
    d: "M56.35 126.42a30.27 30.27 0 00-1.35 3.09c-.48 1.46-.72 3-1.17 4.47a32.82 32.82 0 00-1.46 4.36c-.31 2.06-2 3.89-1 6.16",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path187",
    d: "M62.52 191.58c2 .56 4.11 1.11 6.16 1.69 1.6.45 3.18.95 4.77 1.39 1.44.4 2.9.75 4.34 1.13",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path188",
    d: "M33 270.2c.89 1.72 1.8 3.44 2.66 5.18s1.8 3.73 2.65 5.61c.44 1 .55 2.13 1.19 2.9.88 1.08.62 2.93 2.33 3.4",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path189",
    d: "M28.33 252.54c-1.58 1.88-1.19 4.31-1.79 6.46a46.78 46.78 0 00-.88 5c-.24 1.49-.45 3-.71 4.48-.09.57-.27 1.13-.41 1.69",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path190",
    d: "M40.94 254.36c-2.4.09-4.54-1.09-6.86-1.43a26.33 26.33 0 01-3.65-1.09",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path191",
    d: "M26.08 252.12c-2 .75-4 1.46-6 2.25s-4 1.68-6 2.51c-1 .4-2 .75-2.94 1.13",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path192",
    d: "M7.73 261.51c-.52 1.49-1 3-1.56 4.48s-.22 2.12 1.12 2.83a30.46 30.46 0 013.24 2.18c.93.67 1.81 1.47 3.08 1.4",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path193",
    d: "M248.34 347.55c-3.92-4.81-7.83-9.64-11.8-14.41a6.93 6.93 0 00-1.79-1.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path194",
    d: "M247.5 363.67c1.35.14 2.7.33 4.06.4s2.62 0 3.93 0 2.52.17 3.78.27",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path195",
    d: "M63.36 109.6c-.94 2-1.88 4-2.8 6a57.11 57.11 0 00-2.48 5.62c-.5 1.54-1.67 3-1.17 4.75",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path196",
    d: "M248.62 347.83c3.08 3.78 6.15 7.58 9.26 11.34.92 1.12 1.95 2.16 2.93 3.23",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path197",
    d: "M64.48 181.07c4.48 4.21 9 8.4 13.44 12.63.343.424.629.891.85 1.39",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path198",
    d: "M183.18 250.58a12.69 12.69 0 004.9 1.86c1.287.258 2.55.62 3.78 1.08 2.06.65 4.12 1.3 6.17 2a6.79 6.79 0 011 .55",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path199",
    d: "M251 243c-.37-1.36-1.78-1.28-2.69-1.76-1.9-1-4-1.62-6-2.45-1.33-.56-2.62-1.21-3.93-1.81",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path200",
    d: "M80.46 220.17c1.82.47 3.65.89 5.46 1.41s3.43 1.21 5.19 1.64c1.203.2 2.42.303 3.64.31",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path201",
    d: "M11 260.81l12.19 9.25",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path202",
    d: "M25.24 270.34a10.33 10.33 0 001.26-.15c1.74-.45 3.33-1.42 5.19-1.39",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path203",
    d: "M32.81 268.09l3.19-1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path204",
    d: "M26.22 329.89c-.42 3.6-.93 7.19-1.21 10.8a5.75 5.75 0 00.72 3.68c1 1.6 1.4 3.54 2.19 5.27 1.1 2.37 2.32 4.68 3.49 7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path206",
    d: "M20.9 274.54a20.25 20.25 0 002.05 7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path207",
    d: "M49.49 396.6c-1.91.31-3-1.2-4.17-2.15-2.68-2.1-5.17-4.45-7.75-6.67a7.58 7.58 0 00-1.12-.71",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path208",
    d: "M55.09 175.05a3.12 3.12 0 00.25 2.67c.64 1.35 1 2.81 1.58 4.19.86 2.11 1.77 4.21 2.66 6.31",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path209",
    d: "M66.86 166.78a2.83 2.83 0 01-2.23 1.86 9.17 9.17 0 00-2.39 1c-2.2 1-4.41 2-6.57 3.1-.47.24-.77.81-1.14 1.24",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path210",
    d: "M52 185.84c-.31 1 .39 1.7.86 2.36 2.19 3.08 4.45 6.11 6.72 9.11.457.487.97.916 1.53 1.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path211",
    d: "M49.91 184.58a8.83 8.83 0 00-.67 2.1c-.11 1.53 0 3.08 0 4.62",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path212",
    d: "M49.21 195.93c-.1.51-.75 9-.85 9.55",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path213",
    d: "M78.49 197.05a13.15 13.15 0 01-5 1.42c-2.21.33-4.4.8-6.58 1.26-.36.08-.66.45-1 .68",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path214",
    d: "M79.05 220.31c.33 1.87.65 3.74 1 5.6.19 1 .93 1.22 1.82 1.12 2-.22 4-.46 6-.69l2.53-.29",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path215",
    d: "M92.23 225.77l2.94-1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path216",
    d: "M80 226.76c-1.36.23-2.71.47-4.07.69-.6.11-1.21.19-1.82.29",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path217",
    d: "M72.33 228l-2.94.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path218",
    d: "M9.41 260.39c-.24 1.71 1 2.89 1.55 4.34.45 1.28 1 2.53 1.53 3.78.46 1.08.93 2.15 1.4 3.23",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path219",
    d: "M13.47 274.26a24.46 24.46 0 01-6 2.27c-.32.07-.57.44-.85.67",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path220",
    d: "M40.24 267.67c.6.28 1.4.41 1.79.87 2.16 2.56 4.23 5.21 6.34 7.82.26.257.54.491.84.7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path221",
    d: "M52.15 281.83c-1.68 1.87-3.35 3.75-5 5.6-.56.6-1.21 1.12-1.82 1.68",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path222",
    d: "M54 212c1 1.45 2 2.92 3.09 4.34 1.7 2.26 3.45 4.49 5.18 6.73",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path223",
    d: "M99.09 343.77a3.87 3.87 0 01-.43 1c-2 2.35-4 4.67-6 7a5.29 5.29 0 00-.57 1.05",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path224",
    d: "M31.83 270.76c-.33 1-.68 2-1 3.08-.44 1.58-.82 3.18-1.28 4.76-.1.32-.45.57-.68.85",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path225",
    d: "M35.75 339.56c-1.26.33-2.51.72-3.78 1-2.24.43-4.49.76-6.73 1.13",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path226",
    d: "M73.73 178.13L68 179.25l-1.4.28-2.24.42",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path229",
    d: "M65.18 216.67c.14 2.14.31 4.29.39 6.44 0 .42-.34.84-.53 1.26",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path230",
    d: "M6.11 268.52a5.81 5.81 0 00-.33 1.4c0 2.31.17 4.62.26 6.93",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path231",
    d: "M7.3 278.18c2 1.64 18 7.15 20 8.72",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path232",
    d: "M17 248.06a32.55 32.55 0 015.44 1.61c1.48.71 3.5.14 4.51 1.89",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path233",
    d: "M61.82 202.93c0 1.08-.08 2.15-.15 3.23-.08 1.44-.2 2.89-.26 4.34.009.609.052 1.216.13 1.82",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path234",
    d: "M68.12 205c.84.47 1.7.91 2.52 1.41a48.91 48.91 0 014.18 2.7c.47.36.59 1.17.87 1.78",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path235",
    d: "M127.82 357.92c-.253.87-.43 1.76-.53 2.66 0 2.1.06 4.21.11 6.31",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path236",
    d: "M199.29 258.85a3 3 0 01-2.24 1.27c-1.36.32-2.71.73-4.06 1.11",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path237",
    d: "M162 275c2.14 2.29 4.28 4.59 6.45 6.85a3 3 0 001 .44",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path238",
    d: "M98 185.56c1.17.46 2.32 1 3.51 1.39s2.71.85 4.06 1.27",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path239",
    d: "M49.49 169.86l4.51 3.93",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path240",
    d: "M55.79 175.05c1.26.79 2.53 1.57 3.78 2.38l3.09 2.1",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path241",
    d: "M91.67 354.42c-.42.79.15 1.3.56 1.81 1.67 2.07 3.36 4.12 5 6.17",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path242",
    d: "M313.22 341.8c-1.45 1.36-2.89 2.72-4.35 4.06-.48.45-1 .85-1.53 1.27",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path243",
    d: "M73.73 166.78c2 1.26 3.94 2.5 5.88 3.79.83.55 1.59 1.21 2.39 1.81",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path244",
    d: "M19.64 318.68l5.6 7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path245",
    d: "M111.15 330.17c-.89 1.08-1.8 2.13-2.65 3.24a7.93 7.93 0 00-.72 1.39",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path246",
    d: "M60.7 193.12l.28.42",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path247",
    d: "M61.26 195.65l.28.7",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path248",
    d: "M106.24 186.82l-5.18-3.09",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path249",
    d: "M99.23 183.73l-1.4 1.41",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path250",
    d: "M86.9 175.61a4.13 4.13 0 00-2.52-2.11.47.47 0 01-.28-.14c-1.36-1.81-2.48-.56-3.65.28a25.91 25.91 0 00-2.63 1.86 8.15 8.15 0 00-1.15 1.93",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path251",
    d: "M18.52 272.86c-1 .28-2.06.58-3.09.83a4.57 4.57 0 01-1 0",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path252",
    d: "M92 179c-.29 1.46.91 2.08 1.67 2.95.35.4.66.83 1 1.25",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path253",
    d: "M95.87 184.86l.42.28",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path254",
    d: "M50.89 208.26l2 2.94",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path255",
    d: "M116.05 328.21a1.4 1.4 0 001.39 1.18 14.28 14.28 0 013 1.06",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path256",
    d: "M65.74 214c.75.38 1.52.72 1.68 1.68",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path257",
    d: "M120.11 326.67c-.23.19-.44.47-.7.54-.88.24-1.77.39-2.66.58",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path258",
    d: "M67.28 204.89l-1 2.11",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path259",
    d: "M58.73 212.74l.85 1.26",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path260",
    d: "M63.78 105l.14 1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path261",
    d: "M63.5 212.74l-1.26 1.12",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path262",
    d: "M63.08 223.53l-.56-.07",
    transform: "translate(-4.78 -13.73)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path263",
    d: "M234.03 443.96c1 .52 1.93 1.11 2.95 1.53 2.36 1 4.75 1.91 7.14 2.81 2.89 1.1 5.81 2.12 8.68 3.24 2 .78 3.92 1.71 5.9 2.5 1.23.49 2.52.85 3.78 1.28.93.32 1.88.62 2.8 1 1.6.63 3.19 1.28 4.76 2 1.09.47 2.13 1.07 3.23 1.52 1.95.79 3.92 1.52 5.89 2.25s4.11 1.48 6.16 2.25c1.31.49 2.62 1 3.92 1.54 1 .4 2 .87 3 1.25 1.58.59 3.19 1.07 4.75 1.71 1.16.47 2.24 1.14 3.38 1.65.86.38 1.76.68 2.66 1 1.3.44 2.64.78 3.92 1.28 1.79.69 3.54 1.49 5.33 2.22 1.44.58 2.9 1.11 4.34 1.69 1.92.78 3.82 1.61 5.75 2.37s3.85 1.49 5.85 2.22c1.23.42 2.51.67 3.78 1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-g4_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.74 192.252)",
    style: {
      animation: "face_main-g4_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g4",
    transform: "translate(-377.74 -192.252)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path264",
    d: "M346.15 178.27l9.25 7.73 5.05 4.2c3.27 2.71 6.55 5.41 9.81 8.13s6.52 5.54 9.81 8.26 6.83 5.5 10.22 8.28c1.67 1.36 3.26 2.82 4.92 4.19 2.32 1.94 4.67 3.83 7 5.76 1.41 1.15 2.82 2.31 4.2 3.5 2.21 1.9 4.39 3.83 6.59 5.74.6.52 1.21 1 1.82 1.54",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path265",
    d: "M419.73 192.84l-7.57-1.26h-.28c-1.51-1.43-3.7-.44-5.35-1.5a4.9 4.9 0 00-2.22-.44c-1.62-.12-3-.94-4.76-1-1.93 0-3.82-1.07-5.75-1.54s-3.83-.76-5.74-1.15c-.71-.15-1.41-.36-2.11-.56a8.21 8.21 0 00-.84-.27c-2.15-.38-4.3-.71-6.44-1.14-1.1-.23-2.14-.69-3.23-1-2.37-.59-4.76-1.15-7.15-1.68-2.23-.5-4.48-.91-6.72-1.42-1.88-.42-3.74-.93-5.61-1.39-.46-.11-.93-.18-1.4-.28a41.16 41.16 0 01-7.16-1.77c-.57-.23-1.39.13-2.09.23",
    transform: "translate(-4.78 -13.73)"
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-g5_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.46 406.06)",
    style: {
      animation: "face_main-g5_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g5",
    transform: "translate(-388.46 -406.06)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path266",
    d: "M416.64 375.44a4 4 0 01-.43 1.24 817.8 817.8 0 01-8 9.83c-3.68 4.49-7.4 8.94-11.06 13.46-3.49 4.31-6.87 8.72-10.39 13-4.43 5.42-9 10.73-13.43 16.14-2.4 2.93-4.67 6-7 8.95-.74.93-1.6 1.77-2.37 2.68a2.63 2.63 0 00-.29.83",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path267",
    d: "M362.83 442a4.29 4.29 0 011.39 0c1.43.55 2.8 1.22 4.22 1.79.82.33 1.68.57 2.52.85 2.24.75 4.51 1.42 6.72 2.27 2 .78 4 1.83 6 2.62s4.32 1.18 6.25 2.21c1.21.64 2.65.57 3.76 1.66.74.72 2.18.7 3.29 1.06s2.45.79 3.64 1.27c1.38.55 2.69 1.27 4.08 1.78 1.08.4 2.5.27 3.29 1a7.92 7.92 0 003 1.27c2.44.82 4.66 2.27 7.27 2.57",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path268",
    d: "M416.78 376.42c.84 1.12 1.76 2.19 2.51 3.37 1.14 1.78 2.16 3.63 3.24 5.46",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path269",
    d: "M418.46 462.6c.19.19.35.47.57.54 1 .32 2 .62 2.94.85a13.28 13.28 0 001.68.15",
    transform: "translate(-4.78 -13.73)"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path270",
    d: "M157.22 424.35l-5.31 2.92c-1.54.84-3.08 1.69-4.63 2.52s-2.89 1.5-4.34 2.24-3 1.5-4.48 2.25l-5.33 2.66c-.71.36-1.4.75-2.1 1.12-3 1.59-6.08 3.16-9.1 4.78a10.67 10.67 0 00-1.55 1.24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path271",
    d: "M120.94 445.37c2.34.42 4.69.77 7 1.28 2.08.46 4.12 1.1 6.17 1.66 2.43.66 4.85 1.36 7.29 1.95 2.23.53 4.49.92 6.72 1.42 2.77.62 5.51 1.34 8.28 1.94 2.48.55 4.87 1.4 7.41 1.75a39.46 39.46 0 015.62 1.63c.09 0 .18.12.28.13 1.77.34 3.56.61 5.32 1 2.25.51 4.48 1.13 6.73 1.66 2.1.5 4.22.88 6.3 1.44a22.16 22.16 0 012.95 1.23",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-path272_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.43 302.596)",
    style: {
      animation: "face_main-path272_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path272",
    d: "M21.87-32.256c-1.87 2.24-3.77 4.46-5.6 6.73-2.09 2.59-4.08 5.26-6.19 7.84-2.47 3-5.09 5.94-7.54 9-3 3.69-5.78 7.49-8.71 11.19-1.53 1.92-3.2 3.73-4.75 5.62-3.48 4.24-6.92 8.5-10.38 12.75-.86 1.07-.79 1.35.42 1.83a40.88 40.88 0 007.56 2c2 .38 3.92 1.24 5.9 1.76 2.93.76 6 1.11 8.78 2.24 1.55.63 3.28.41 4.69 1.38.41.28 1.18 0 1.65.21 1.87.92 4 1.08 5.91 1.74a12.15 12.15 0 003.21.19",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(358.89 89.447)",
    style: {
      animation: "face_main-g6_to__to 10000ms linear infinite normal forwards"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g6",
    transform: "translate(-358.89 -89.447)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path273",
    d: "M385 92.51c-2 0-4 .11-5.9-.8a6.35 6.35 0 00-2.37-.18c-.62 0-1.23.08-1.7-.54a1.35 1.35 0 00-1-.29 11.25 11.25 0 01-4.5-.81 7.46 7.46 0 00-2.65-.31c-.91 0-1.8.08-2.54-.69-.21-.21-.73-.11-1.1-.17-1.21-.18-2.43-.36-3.64-.56a16.65 16.65 0 01-3.35-.59c-2.41-.95-5.11-.42-7.46-1.62-.41-.21-1.05.1-1.52 0-2.79-.92-5.8-.81-8.57-1.89a13.07 13.07 0 00-3.63-.33",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path274",
    d: "M334.24 84a2.8 2.8 0 001.66 2c1.72.93 3.29 2.12 4.93 3.18 2.33 1.51 4.68 3 7 4.49 1.75 1.14 3.44 2.36 5.2 3.49s3.37 2 5 3.1q4.08 2.57 8.13 5.19c.87.56 1.69 1.2 2.53 1.81",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path275",
    d: "M393.1 122.64c-.93-.56-1.88-1.1-2.8-1.69-2.53-1.62-5-3.27-7.58-4.89a5.94 5.94 0 00-1.11-.43",
    transform: "translate(-4.78 -13.73)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path276",
    d: "M273.97 410.47a22.08 22.08 0 01-2.26 2.37q-7.25 5.73-14.56 11.36c-5.58 4.28-11.22 8.5-16.81 12.76-1.48 1.13-2.89 2.34-4.35 3.5a7.3 7.3 0 01-1 .56",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path277",
    d: "M173.91 419.02c1.45 2.66 2.72 5.43 3.94 8.18.76 1.72 1.65 3.44 2.28 5.26.81 2.31 2 4.5 3 6.74 1.16 2.52 2.17 5.14 3.57 7.53.71 1.2.59 2.76 1.86 3.73.43.33.33 1.3.61 1.9.7 1.48 1.51 2.89 2.21 4.37.126.452.18.921.16 1.39",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path278",
    d: "M273.27 410.19c-.1 0-.19-.14-.28-.13l-8.27.41",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path279",
    d: "M261.78 410.47a6.11 6.11 0 01-1.41.41c-3.22.12-6.47-.06-9.66.35-4.71.62-9.43.61-14.16.78-1.07 0-2.18.71-3.22-.14",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path280",
    d: "M231.93 445.09c-.1 1.07-.19 2.14-.28 3.22",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path281",
    d: "M231.37 450.41c-.19 1.78-.38 3.55-.56 5.33q-.36 3.63-.7 7.28l-.42 4.35",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path282",
    d: "M229.41 468.91c-.19 2.29-.33 4.58-.58 6.86-.22 2.07-.55 4.12-.83 6.17",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path283",
    d: "M120.22 445.51a6.34 6.34 0 00.58 1.8c3.61 4.89 7.29 9.71 10.9 14.6 3 4 5.88 8.13 8.85 12.18 1.83 2.5 3.72 5 5.61 7.42a3.2 3.2 0 00.83.57",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.225 18.705)",
    style: {
      animation: "face_main-g7_to__to 10000ms linear infinite normal forwards"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g7",
    transform: "rotate(-9.379 75.599 2320.86)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path284",
    d: "M404.31 22.16c-2.15.42-4.45.5-6.4 1.37-1.5.68-3.06.7-4.54 1.25-1.72.64-3.55.94-5.31 1.46-1.6.46-3.18 1-4.77 1.52-.6.18-1.22.28-1.82.43-1.5.37-3 .71-4.48 1.13-1.84.52-3.62 1.25-5.48 1.63a18 18 0 00-4.51 1.58",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path285",
    d: "M366.89 32.53c-1 .88-2.14.11-3.22.14",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path286",
    d: "M366.75 33a3.91 3.91 0 002.1.9c1.94.39 3.84 1.07 5.75 1.62.414.117.835.21 1.26.28h.7c1.83.46 3.65.92 5.47 1.4a14.69 14.69 0 011.82.56c1.9.78 4.09.54 5.89 1.67a1 1 0 00.42.14l5.6 1a2 2 0 011 .3 4.22 4.22 0 002.53.84c1.69.26 3.37.63 5.05 1",
    transform: "translate(-4.78 -13.73)"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path287",
    d: "M230.53 443.96a55.75 55.75 0 01-6.86 3.67c-2.19 1-4.3 2.25-6.46 3.33-1.66.84-3.38 1.57-5 2.41-.88.44-1.69 1-2.54 1.52a11.45 11.45 0 01-2.24 1.24c-3.07 1-5.67 3-8.67 4.13a24.12 24.12 0 00-3.52 2.06",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path288",
    d: "M109.31 460.27c2.61 1.78 5.21 3.58 7.85 5.32 2.21 1.44 4.5 2.78 6.72 4.22 1.52 1 3 2.07 4.49 3.07 2.32 1.51 4.68 3 7 4.49 1.71 1.13 3.35 2.36 5.06 3.49.83.54 1.76.94 2.65 1.41",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-g8_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.125 442.845)",
    style: {
      animation: "face_main-g8_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g8",
    transform: "translate(-284.125 -442.845)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path289",
    d: "M304.25 444c-1.53 0-2.75.8-4.06 1.4a12.47 12.47 0 01-3.51 1.46c-1.29.14-2.19.94-3.32 1.31a66.66 66.66 0 00-8.71 3.72c-1.08.52-2.22 1-3.29 1.52-1.63.73-3.35 1.33-5 2.09-.81.38-1.59.83-2.39 1.25",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path290",
    d: "M273.56 457.41a1.86 1.86 0 001.68 1c.48 0 .93.46 1.41.66 2.56 1.09 5.16 2.1 7.7 3.25 1.61.73 3.32 1.24 4.87 2 2.13 1.06 4.36 1.84 6.46 2.92 1 .53 2.39.39 3.17 1.59.22.34 1.15.22 1.76.32",
    transform: "translate(-4.78 -13.73)"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path291",
    d: "M191.15 464.14c-1.68 1.08-3.33 2.21-5.05 3.21-2.4 1.41-4.87 2.7-7.28 4.09-1.61.93-3.16 2-4.77 2.92-1.85 1.07-3.75 2-5.6 3.1s-3.9 2.39-5.9 3.48a27.87 27.87 0 01-3.21 1.28",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path292",
    d: "M195.63 464c5.7 4.16 11.41 8.3 17.09 12.48 2.09 1.54 4.1 3.2 6.19 4.74a9.73 9.73 0 001.81.86",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-g9_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.43 382.005)",
    style: {
      animation: "face_main-g9_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g9",
    transform: "translate(-294.43 -382.005)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path293",
    d: "M287.58 381c.14.38.17.86.43 1.11 2.5 2.34 4.38 5.17 6.46 7.84 1.76 2.28 3.74 4.39 5.57 6.61s3.38 4.2 5 6.3c.85 1.07 1.69 2.15 2.53 3.23",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path294",
    d: "M307.9 406.27c.23.37.45.76.7 1.11.74 1 1.49 2.06 2.24 3.09",
    transform: "translate(-4.78 -13.73)"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path295",
    d: "M158.36 424.07a15.18 15.18 0 001.41 2.08c2.63 2.84 5.31 5.63 8 8.42.442.406.91.784 1.4 1.13",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path296",
    d: "M169.99 436.96c1.87 2 3.76 3.9 5.6 5.89 3.47 3.76 6.91 7.56 10.38 11.34 1.29 1.42 2.58 2.84 3.94 4.19a5 5 0 001.52.72",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-g10_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.48 157.94)",
    style: {
      animation: "face_main-g10_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g10",
    transform: "translate(-458.48 -157.94)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path297",
    d: "M450.7 164.26c.35 1.57 1.94 1.63 3 2.35 2.22 1.55 4.55 2.94 6.85 4.37s4.78 2.87 7.14 4.35c1.8 1.13 3.54 2.35 5.33 3.49.9.57 1.87 1 2.8 1.55",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path298",
    d: "M469.61 163h-7.56c-1 0-2-.07-2.94 0-2.58.24-5.14.55-7.71.83",
    transform: "translate(-4.78 -13.73)"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path299",
    d: "M106.37 461.62c-2.15 3.79-4.29 7.58-6.46 11.35q-2.34 4.08-4.77 8.12a5.34 5.34 0 01-1.11 1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path300",
    d: "M196.05 414.96c-1.77 0-3.55 0-5.32.15s-3.55.43-5.33.53c-2.8.16-5.6.2-8.41.3a3.06 3.06 0 00-.56.14",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-path301_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.93 413.42)",
    style: {
      animation: "face_main-path301_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path301",
    d: "M-7.15-9.81c1.59 1.14 2.3 3 3.36 4.49C-2.04-2.77-.33-.19 1.4 2.38c1.11 1.64 2.19 3.3 3.38 4.89a31.41 31.41 0 002.37 2.54",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path302",
    d: "M207.54 419.44c2 2 3.91 3.94 5.89 5.88q4.68 4.57 9.39 9.12l1.4 1.4",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path303",
    d: "M172.93 418.18c-1.08 1.3-.53 3-1 4.41",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path304",
    d: "M171.67 424.35c-.42 3.08-.82 6.17-1.28 9.24a15.29 15.29 0 01-.68 2.25",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path305",
    d: "M197.45 444.39c-1.23 2.61-1 5.54-1.78 8.27-.43 1.51-.42 3.14-.77 4.68a33.63 33.63 0 01-1.23 3.58",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      animation: "face_main-g11_to__to 10000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(477.165 385.18)",
    style: {
      animation: "face_main-g11_tr__tr 10000ms linear infinite normal forwards"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "animated_logo_face_white_svg__face_main-g11",
    transform: "translate(-477.165 -385.18)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path306",
    d: "M494 390.29c-1.22.19-2.43.47-3.65.54-2.61.16-5.23.21-7.84.3",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path307",
    d: "M469.89 392.67a15.86 15.86 0 004.2 3.11c2 1.22 3.93 2.59 5.89 3.9",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path308",
    d: "M493.16 407.53c-1.5-.84-3-1.64-4.48-2.54-1.76-1.07-3.46-2.24-5.2-3.33-.15-.09-.46.07-.69.12",
    transform: "translate(-4.78 -13.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path309",
    d: "M474.66 392H471",
    transform: "translate(-4.78 -13.73)"
  }))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path310",
    d: "M118.28 445.51c-1.45 1.82-2.92 3.62-4.34 5.47-1.2 1.56-2.34 3.17-3.51 4.75-.46.62-.93 1.22-1.4 1.83",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path311",
    d: "M171.67 417.06c-3.92 2-7.84 4.12-11.78 6.15a3.86 3.86 0 01-1.25.16",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path312",
    d: "M214.55 413.7l-7 .28c-.56 0-1.12.09-1.68.14",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path313",
    d: "M201.52 414.68l-3.22.28",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path314",
    d: "M225.41 436.96l4.28 4.06",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path315",
    d: "M226.88 412.86l2 .14",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "animated_logo_face_white_svg__face_main-path316",
    d: "M202.5 415.27c-.19 1.12-.37 2.24-.56 3.36",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

export default SvgAnimatedLogoFaceWhite;